import ReactDOM from 'react-dom/client';
import { v2Component } from '../../..';
import { EmailHistory } from './email-history';
import { DateTime } from 'luxon';
import { ToastContainer } from 'react-toastify';
import { AdminContextProvider } from '../../../context/admin-context';

export function initEmailHistory() {
  document.getElementsByName('order-email-history').forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);

      const bootstrap = () => {
        const { orderId, orderDateAdded } = Object.assign({}, element.dataset) as any;
        root.render(
          v2Component(
            <AdminContextProvider>
              <ToastContainer />
              <EmailHistory
                orderId={String(orderId)}
                orderType={'Order'}
                orderDateAdded={DateTime.fromISO(orderDateAdded)}
                className="mt-[18px]"
              />
            </AdminContextProvider>,
          ),
        );
      };

      bootstrap();
    }
  });
}
